// Mock data for Omnia Paratus Talent Solutions

export const jobListings = [
  {
    id: "1",
    title: "Senior Accountant",
    company: "Fortune 500 Financial Services",
    location: "New York, NY",
    industry: "Accounting & Finance",
    type: "Full-time",
    salary: "$85,000 - $105,000",
    description: "Leading financial services firm seeking experienced Senior Accountant to join their growing team. Excellent benefits and growth opportunities.",
    requirements: ["CPA required", "5+ years experience", "Advanced Excel skills"],
    postedDate: "2025-01-05"
  },
  {
    id: "2",
    title: "Registered Nurse - ICU",
    company: "Premier Healthcare System",
    location: "Chicago, IL",
    industry: "Healthcare",
    type: "Full-time",
    salary: "$75,000 - $95,000",
    description: "Award-winning hospital system seeking compassionate RN for ICU department. Competitive pay and comprehensive benefits package.",
    requirements: ["RN License", "ICU experience preferred", "BLS/ACLS certified"],
    postedDate: "2025-01-08"
  },
  {
    id: "3",
    title: "Supply Chain Manager",
    company: "Global Logistics Corporation",
    location: "Atlanta, GA",
    industry: "Logistics & Supply Chain",
    type: "Full-time",
    salary: "$95,000 - $120,000",
    description: "Innovative logistics company looking for strategic Supply Chain Manager to optimize operations and drive efficiency.",
    requirements: ["7+ years SCM experience", "Lean Six Sigma preferred", "Leadership skills"],
    postedDate: "2025-01-10"
  },
  {
    id: "4",
    title: "HR Compliance Manager",
    company: "Tech Innovation Group",
    location: "San Francisco, CA",
    industry: "HR & People Compliance",
    type: "Full-time",
    salary: "$95,000 - $120,000",
    description: "Fast-growing tech company needs experienced HR Compliance Manager to ensure regulatory compliance and develop people policies.",
    requirements: ["HR certification preferred", "5+ years HR compliance experience", "Tech industry experience a plus"],
    postedDate: "2025-01-12"
  },
  {
    id: "5",
    title: "Financial Analyst",
    company: "Investment Management Firm",
    location: "Boston, MA",
    industry: "Accounting & Finance",
    type: "Full-time",
    salary: "$70,000 - $85,000",
    description: "Seeking detail-oriented Financial Analyst to support portfolio management and client reporting.",
    requirements: ["Bachelor's in Finance", "2+ years experience", "Strong analytical skills"],
    postedDate: "2025-01-14"
  },
  {
    id: "6",
    title: "Nurse Practitioner",
    company: "Community Health Network",
    location: "Denver, CO",
    industry: "Healthcare",
    type: "Full-time",
    salary: "$100,000 - $120,000",
    description: "Growing healthcare network seeking NP to provide patient-centered care in primary care setting.",
    requirements: ["NP License", "DEA certification", "Primary care experience"],
    postedDate: "2025-01-15"
  }
];

export const testimonials = [
  {
    id: "1",
    name: "Sarah Mitchell",
    title: "CFO, Healthcare Partners Inc.",
    content: "Omnia Paratus found us the perfect Senior Financial Analyst in just three weeks. Their understanding of our culture and needs was exceptional.",
    rating: 5
  },
  {
    id: "2",
    name: "Michael Chen",
    title: "Hired as Supply Chain Director",
    content: "The team at Omnia Paratus was incredibly responsive and helped me find a role that perfectly matched my career goals. Highly recommend!",
    rating: 5
  },
  {
    id: "3",
    name: "Jennifer Rodriguez",
    title: "VP of Operations, Logistics Solutions",
    content: "We've worked with many recruiting firms, but Omnia Paratus stands out. They deliver quality candidates who are the right cultural fit.",
    rating: 5
  }
];

export const industries = [
  {
    id: "1",
    name: "Accounting & Finance",
    icon: "calculator",
    description: "From staff accountants to CFOs, we connect finance professionals with organizations that value strategic financial leadership.",
    specialties: ["Public Accounting", "Corporate Finance", "Financial Analysis", "Tax & Audit"]
  },
  {
    id: "2",
    name: "Healthcare",
    icon: "heart-pulse",
    description: "Placing compassionate healthcare professionals in roles where they can make a meaningful difference in patient care.",
    specialties: ["Nursing", "Allied Health", "Healthcare Administration", "Medical Support"]
  },
  {
    id: "3",
    name: "Logistics & Supply Chain",
    icon: "truck",
    description: "Connecting supply chain experts with organizations seeking to optimize operations and drive efficiency.",
    specialties: ["Supply Chain Management", "Procurement", "Warehouse Operations", "Transportation"]
  },
  {
    id: "4",
    name: "HR & People Compliance",
    icon: "users",
    description: "Connecting HR and compliance professionals with organizations seeking to build strong people operations and maintain regulatory compliance.",
    specialties: ["HR Management", "People Operations", "Compliance", "Employee Relations"]
  }
];

export const services = [
  {
    id: "1",
    name: "Contingent Direct Hire Recruiting",
    description: "Our core service delivering exceptional talent on a success-fee basis. We only succeed when you do.",
    benefits: [
      "No upfront costs or retainers",
      "Rigorous candidate screening",
      "Industry-specific expertise",
      "90-day placement guarantee"
    ],
    process: [
      "Discovery consultation to understand your needs",
      "Targeted candidate sourcing and screening",
      "Presentation of qualified candidates",
      "Interview coordination and support"
    ]
  },
  {
    id: "2",
    name: "Talent Pipeline Development",
    description: "Proactive talent mapping to ensure you have access to top candidates when you need them most.",
    benefits: [
      "Reduced time-to-hire",
      "Access to passive candidates",
      "Market intelligence insights",
      "Strategic workforce planning"
    ],
    process: [
      "Analyze your talent requirements",
      "Build and nurture candidate relationships",
      "Maintain warm talent pools",
      "Rapid deployment when positions open"
    ]
  }
];

export const whyChooseUs = [
  {
    id: "1",
    title: "Personalized Approach",
    description: "We're not a volume placement firm. Every search gets dedicated attention and strategic focus.",
    icon: "users"
  },
  {
    id: "2",
    title: "Deep Industry Expertise",
    description: "Years of specialized experience in accounting, healthcare, logistics, and HR & people compliance recruiting.",
    icon: "briefcase"
  },
  {
    id: "3",
    title: "Responsive Communication",
    description: "We pride ourselves on quick response times and keeping you informed throughout the process.",
    icon: "message-square"
  },
  {
    id: "4",
    title: "Long-term Fit Focus",
    description: "We prioritize cultural fit and career alignment over quick placements that don't last.",
    icon: "target"
  }
];

export const companyInfo = {
  email: "contact@omniaparatustalent.io",
  phone: "(978) 340-6952",
  serviceArea: "Boston, MA",
  mission: "To deliver impactful hiring solutions that drive measurable business outcomes through strategic talent acquisition.",
  story: "Omnia Paratus was founded on the belief that recruiting should be more than transactional. Our team brings decades of combined experience in talent acquisition, and we built this firm to provide a more personalized, strategic approach to hiring. We take the time to understand both our clients' business objectives and our candidates' career aspirations, ensuring successful, long-lasting matches.",
  values: [
    {
      name: "Integrity",
      description: "We build relationships on trust, transparency, and ethical business practices."
    },
    {
      name: "Partnership",
      description: "We view our clients and candidates as long-term partners, not transactions."
    },
    {
      name: "Results",
      description: "We're committed to delivering measurable outcomes that impact your bottom line."
    },
    {
      name: "Responsiveness",
      description: "We understand that timing matters in talent acquisition and respond accordingly."
    }
  ]
};
